import { SEO_SPACER } from '@/lib/seoSpacer.ts'
import * as React from 'react'

import styles from './GettingStarted.module.scss'

export type ResourceProps = {
	key: string
	copy: string
	href: string
}

export type GettingStartedProps = {
	title: string
	resources: ResourceProps[]
}

export const GettingStarted: React.FC<GettingStartedProps> = ({
	title,
	resources,
}) => (
	<section className={styles.gettingStartedWrapper}>
		<div className={styles.gettingStarted}>
			<h2>
				{title}
				{SEO_SPACER}
			</h2>
			{resources && (
				<ul>
					{resources.map((resource) => (
						<li key={resource.key}>
							<a
								href={resource.href}
								target="_blank"
								rel="noopener noreferrer"
								className={styles.linkRow}
							>
								<span>{resource.copy}</span>
								<i className="material-icons">chevron_right</i>
							</a>
						</li>
					))}
				</ul>
			)}
		</div>
	</section>
)
